import React from 'react'
import { Link, Switch, Route, useRouteMatch } from './routing';
import { View, TouchableOpacity, Text, Button } from 'react-native';
import GrammarTestCase from './GrammarTestCase.js'
import Styles from './Styles.js'

class GrammarTest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  render() {
    return (
      <React.Fragment>
        <View style={Styles.grammarTestContainer}>
          <GrammarTestCase />
        </View>
      </React.Fragment>
    )
  }
}
export default GrammarTest
